import SensorTypesApi from '@/api/sensorTypes';


export default {
  namespaced: true,
  state: {
    list: [],
    listByKey: {},
    meta: {},
    loading: false,
    error: null,
    params: {}
  },

  actions: {
    async getList(ctx) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);
      try {
        const { data, meta } = await SensorTypesApi.getList();
        ctx.commit('setListByKey', data[0]);
        ctx.commit('setList', data);
        ctx.commit('setMeta', meta);
      } catch (error) {
        console.log('ERROR', error);
        ctx.dispatch('errors/pushError', { id: 'sensorTypes', error: error.message }, { root: true });
        ctx.commit('setError', error);
      } finally {
        ctx.commit('setLoading', false);
      }
    },
  },

  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },

    setError(state, err) {
      state.error = err;
    },

    setMeta(state, meta) {
      state.meta = meta;
    },

    setList(state, data) {
      state.list = data;
    },

    setListByKey(state, data) {
      state.listByKey = data;
    },
  },

  getters: {
    meta: state => state.meta,
    error: state => state.error,
    loading: state => state.loading,
    listByKey: state => state.listByKey,
    list: state => (state.list ? state.list : []),
    params: state => state.params
  }
};
